import React from 'react';
import PropTypes from 'prop-types';
import { prettyCalendarTennisUrl, isHideStandingLink } from '../../common/rcs_gaz_mc_core_FE';
import { CompetitionLastRowWrapper, CompetitionCalendar, CompetitionStandings } from './styles';
import LabelLink from '../shared/LabelLink';
import ConfigManager from '../../common/configManager/configManager';
import * as types from '../../constants';

const CompetitionLastRow = ({
  competitionId, dictionary, isRace, isTennis, isBasket, disableLink, sportId,
  competitionName, tournamentType, tournamentName, competitionSex,
}) => {
  const corriereLink = () => {
    let returnedLink = '';
    if (process.env.REACT_APP_SITE === 'corriere') {
      returnedLink = '/sport';
    }
    return returnedLink;
  };

  const tennisCleanTournament = (type) => {
    let label;
    if (type && type.indexOf('/') !== -1) {
      const typesArray = type.split(' / ');
      const [first, second] = typesArray;
      if (competitionSex === types.COMPETITION_TYPE_MAN) {
        label = first;
      } else {
        label = second;
      }
    } else {
      label = type;
    }
    return label;
  };

  return (
    <CompetitionLastRowWrapper competitionId={competitionId} className="competition-title-row-last">
      {!isTennis && !isBasket &&
      <CompetitionCalendar competitionId={competitionId}>
        {process.env.REACT_APP_SITE === 'gazzetta' || process.env.REACT_APP_SITE === 'corriere' ?
          <LabelLink
            label="Calendario e risultati"
            weight="bold"
            color="linkColor"
            size={0.80}
            path={!isRace ?
              `${corriereLink()}${dictionary.calendarLink[ConfigManager.getEnv()]}${dictionary.competitionLink[Number(competitionId)]}/calendario-risultati/`
              :
              `${corriereLink()}${dictionary.raceCalendarLink[ConfigManager.getEnv()]}${dictionary.raceCompetitionLink[Number(competitionId)]}/calendario-risultati/`
            }
          />
          :
              <LabelLink
                label="Calendario e risultati"
                weight="bold"
                color="linkColor"
                size={0.80}
                path={`${dictionary.gazzanetCalendarLink[ConfigManager.getEnv()]}${dictionary.competitionLink[Number(competitionId)]}/calendario-risultati/`}
              />
        }
      </CompetitionCalendar>
      }
      {isTennis &&
      <CompetitionCalendar competitionId={competitionId}>
        <LabelLink
          disableLink={disableLink}
          label="Calendario"
          weight="bold"
          color="linkColor"
          size={0.80}
          path={`${prettyCalendarTennisUrl('8', competitionId, competitionName, tennisCleanTournament(tournamentType), tournamentName, false, process.env.REACT_APP_SITE)}`}
        />
      </CompetitionCalendar>
      }
      {isBasket &&
      <CompetitionCalendar competitionId={competitionId}>
        <LabelLink
          label="Calendario e risultati"
          weight="bold"
          color="linkColor"
          size={0.80}
          path={`${corriereLink()}/basket/${dictionary.basketCompetitionLink[Number(competitionId)]}/calendario-risultati/`}
        />
      </CompetitionCalendar>
      }
      {isTennis && !tournamentName.toLowerCase().includes('davis') &&
      <CompetitionCalendar competitionId={competitionId}>
        <LabelLink
          label="Tabellone"
          weight="bold"
          color="linkColor"
          size={0.80}
          disableLink={disableLink}
          path={`${prettyCalendarTennisUrl('8', competitionId, competitionName, tennisCleanTournament(tournamentType), tournamentName, true, process.env.REACT_APP_SITE)}`}
        />
      </CompetitionCalendar>
      }
      {!isTennis && !isBasket && !isHideStandingLink(sportId, competitionId) &&
        <CompetitionStandings competitionId={competitionId}>
          {process.env.REACT_APP_SITE === 'gazzetta' || process.env.REACT_APP_SITE === 'corriere' ?
            <LabelLink
              label="Classifica"
              weight="bold"
              color="linkColor"
              size={0.80}
              path={!isRace ?
                `${corriereLink()}${dictionary.calendarLink[ConfigManager.getEnv()]}${dictionary.competitionLink[Number(competitionId)]}/classifica/`
                :
                `${corriereLink()}${dictionary.raceStandingsLink[ConfigManager.getEnv()]}${dictionary.raceCompetitionLink[Number(competitionId)]}/classifiche/`
              }
            />
            :
                <LabelLink
                  label="Classifica"
                  weight="bold"
                  color="linkColor"
                  size={0.80}
                  path={`${dictionary.gazzanetCalendarLink[ConfigManager.getEnv()]}${dictionary.competitionLink[Number(competitionId)]}/classifica/`}
                />
          }
        </CompetitionStandings>
      }
      {isBasket && !isHideStandingLink(sportId, competitionId) &&
        <CompetitionStandings competitionId={competitionId}>
          <LabelLink
            label="Classifica"
            weight="bold"
            color="linkColor"
            size={0.80}
            path={`${corriereLink()}/basket/${dictionary.basketCompetitionLink[Number(competitionId)]}/classifica/`}
          />
        </CompetitionStandings>
      }
    </CompetitionLastRowWrapper>
  );
};

CompetitionLastRow.propTypes = {
  competitionId: PropTypes.any,
  dictionary: PropTypes.any,
  isRace: PropTypes.bool,
  isTennis: PropTypes.bool,
  isBasket: PropTypes.bool,
  competitionName: PropTypes.any,
  tournamentType: PropTypes.any,
  tournamentName: PropTypes.any,
  competitionSex: PropTypes.any,
  disableLink: PropTypes.bool,
  sportId: PropTypes.any,
};

export default CompetitionLastRow;
